import * as React from 'react';
import styles from './expander-background.scss';

export interface DetailsExpanderProps {
  onClick: () => void;
}

export const ExpanderBackground: React.FC<DetailsExpanderProps> = ({onClick}) => {
  return (
    <div>
      <div tabIndex={0} className={styles.expanderBackground} onClick={onClick} onFocus={onClick}/>
    </div>
  );
};
